import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	stroke: "#4F31FF",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 15",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7.5,
		cy: 7.5,
		r: 6.75,
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.69745 8.41382L8.30762 8.41382L8.30762 4.80365",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgClock;
